import { c as _c } from "react/compiler-runtime";
import { Badge, HStack, Separator, type StackProps } from '@chakra-ui/react';
type OrDividerProps = StackProps & {
  /** Center label. Defaults to "OR" to match login/signup forms. */
  label?: string;
};

/**
 * Horizontal "---- OR ----" divider used between primary form actions and
 * alternate options (e.g. email form vs social login).
 *
 * Lines must use `flex={1}` so they stretch; without it Separators collapse
 * and only the label shows.
 */
export const OrDivider = t0 => {
  const $ = _c(10);
  let stackProps;
  let t1;
  if ($[0] !== t0) {
    ({
      label: t1,
      ...stackProps
    } = t0);
    $[0] = t0;
    $[1] = stackProps;
    $[2] = t1;
  } else {
    stackProps = $[1];
    t1 = $[2];
  }
  const label = t1 === undefined ? "OR" : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Separator flex={1} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== label) {
    t3 = <Badge flexShrink={0} fontSize="2xs" opacity={0.5} variant="label">{label}</Badge>;
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Separator flex={1} />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== stackProps || $[8] !== t3) {
    t5 = <HStack width="full" {...stackProps}>{t2}{t3}{t4}</HStack>;
    $[7] = stackProps;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};